import { SingleValueProps } from "react-select5";
import { Chip } from "@material-ui/core";

type Props = SingleValueProps<any & {label: string, value: any}, false, any> & {
  onDelete?: (value: any) => void;
};

export function SingleValueChip(props: Props) {
  if (!props.data?.value) {
    return null;
  }

  return (
    <div>
      <Chip label={props.data?.label} onDelete={props.onDelete} size="small" />
    </div>
  );
}
